import React from 'react'

import { FirstName as CoreFirstName, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

const { isText, maxLength, minLength } = Util.validations

export const FirstName = () => {
  const { getLabel } = useIntl()

  return (
    <CoreFirstName
      label={getLabel('checkout.contact.firstName')}
      errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
      validations={[minLength(2), maxLength(30), isText]}
    />
  )
}
